import React from "react";
import { Accordion } from "react-bootstrap";
import "../../../stylesheets/components/Reports/UnderstandingSections/UnderstandingSectionMob.scss";
import { GTMService } from "@di";
import { ReportGAEvents } from "@domains/trackers/gtmService";
import { ReportsGTMConstants } from "@domains/aggregates/Reports/ReportsGAConstants";
const UnderstandingSectionMob = ({ understandingData, reportType }) => {
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "auto",
        });
    };
    const clickOnUnderstandingSection = (fieldName) => {
        GTMService.gtmService(new ReportGAEvents(`${fieldName} `, `${ReportsGTMConstants.NewReports} |  ${reportType}`, `${fieldName}`));
    };
    return (React.createElement("div", null,
        React.createElement("div", null,
            React.createElement("div", null,
                React.createElement("p", { className: "section_head" },
                    React.createElement("b", null, "Understanding"),
                    " Sections")),
            React.createElement("div", { className: "accordian_container" },
                React.createElement("div", { className: "seperation_line" }),
                understandingData &&
                    understandingData.reportDetails &&
                    understandingData.reportDetails.length > 0 &&
                    understandingData.reportDetails.map((ele, idx) => {
                        return (React.createElement("div", { key: idx, onClick: () => clickOnUnderstandingSection(ele.fieldName) },
                            React.createElement(Accordion, null,
                                React.createElement(Accordion.Item, { eventKey: idx.toString(), className: "accordian-item" },
                                    React.createElement(Accordion.Header, null, ele.fieldName),
                                    React.createElement(Accordion.Body, null,
                                        React.createElement("p", { className: "sub_text" }, ele.description),
                                        React.createElement("div", { className: "back_to_title" },
                                            React.createElement("i", { className: "edel-icon-point-arrow-up" }),
                                            React.createElement("span", { onClick: scrollToTop }, "Back to Title Section"))))),
                            React.createElement("div", { className: "seperation_line" })));
                    })))));
};
export default UnderstandingSectionMob;
